declare global {
    interface Window {
        appCurrentVersion?: string;
        versionCheckInterval?: number | undefined | null;
    }
}

export class VersionChecker {
    public async getClientVersion(): Promise<string> {
        const storedVersion: string | null = localStorage.getItem('appVersion');
        return storedVersion ?? '';
    }

    public async hasAuthData(): Promise<boolean> {
        const accessToken: string | null = localStorage.getItem('accessToken');
        const refreshToken: string | null = localStorage.getItem('refreshToken');
        return !!(accessToken || refreshToken);
    }

    public async refreshVersion(serverVersion: string): Promise<void> {
        // Clear all cookies
        document.cookie.split(";").forEach(cookie => {
            const eqPos = cookie.indexOf("=");
            const name = eqPos > -1 ? cookie.substr(0, eqPos).trim() : cookie.trim();

            // Clear for the current path and domain
            document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
            document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=${window.location.hostname}`;

            // Clear for parent domain (handles subdomains)
            const parts = window.location.hostname.split('.');
            if (parts.length > 2) {
                const parentDomain = '.' + parts.slice(-2).join('.');
                document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=${parentDomain}`;
            }
        });

        // Clear storage
        try {
            localStorage.clear();
            sessionStorage.clear();
        } catch (e) {
            console.warn('Could not clear storage:', e);
        }

        localStorage.setItem('appVersion', serverVersion);

        // Force reload with cache bypass
        // window.location.reload(true);
        window.location.reload();
    }
}

(<any>window)['VersionChecker'] = new VersionChecker();
